var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form",
    {
      ref: "ruleForm",
      attrs: {
        model: _vm.currentComponent,
        "label-width": "100px",
        isNeedRequire: "",
        isNeedTooltip: "",
        "label-position": "top",
        size: "small",
      },
    },
    [
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_questionstem"),
            prop: "content",
            rules: _vm.rulesContent,
            size: "small",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.content,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "content", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_itemanswer"),
            size: "small",
            prop: "answerContent",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.answerContent,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "answerContent", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-ote-edit-ques-kw mb24" },
        [
          _vm._l(_vm.currentComponent.keywords, function (item, index2) {
            return _c(
              "yxt-form-item",
              {
                key: index2,
                class: {
                  mb8: _vm.currentComponent.keywords.length - 1 === index2,
                },
                attrs: { label: "", size: "small" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pc_biz_ote_keyword")) +
                          "\n          "
                      ),
                      _c("span", { staticClass: "min-w-16 d-in-block" }, [
                        _vm._v(_vm._s(index2 + 1)),
                      ]),
                    ]),
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "ml4 mr24",
                        attrs: {
                          prop: "keywords." + index2 + ".name",
                          rules: _vm.rulesName,
                          size: "small",
                        },
                      },
                      [
                        _c("yxt-input", {
                          ref: "editorItem_input" + index2,
                          refInFor: true,
                          attrs: { maxlength: "30" },
                          model: {
                            value: item["name"],
                            callback: function ($$v) {
                              _vm.$set(item, "name", $$v)
                            },
                            expression: "item['name']",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_scorerate"))),
                    ]),
                    _c(
                      "yxt-form-item",
                      {
                        staticClass: "ml8",
                        attrs: {
                          prop: "keywords." + index2 + ".rate",
                          rules: _vm.rulesRate,
                          size: "small",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c("yxt-input-number", {
                              staticClass: "mr8",
                              attrs: {
                                "controls-position": "right",
                                min: 1,
                                max: 100,
                              },
                              on: {
                                blur: function ($event) {
                                  return _vm.setScore(item)
                                },
                              },
                              model: {
                                value: item["rate"],
                                callback: function ($$v) {
                                  _vm.$set(item, "rate", $$v)
                                },
                                expression: "item['rate']",
                              },
                            }),
                            _c("span", { staticClass: "shortanswer_score" }, [
                              _vm._v("%"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex flex-mid" },
                              [
                                _c(
                                  "yxt-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t("pc_biz_ote_btn_delete"),
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "yxtbiz-ote-ai-icon hand ml12 color-gray-8",
                                        on: {
                                          click: function ($event) {
                                            return _vm.delItem(index2)
                                          },
                                        },
                                      },
                                      [
                                        _c("yxt-svg", {
                                          attrs: {
                                            width: "16px",
                                            height: "16px",
                                            "icon-class": "delete",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          _c(
            "div",
            [
              _c(
                "yxt-button",
                {
                  attrs: {
                    type: "text",
                    disabled:
                      _vm.currentComponent.keywords &&
                      _vm.currentComponent.keywords.length >= 10,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addItem()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-mid" },
                    [
                      _c("yxt-svg", {
                        staticClass: "mr4",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "common_plus",
                        },
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_addnewkeyword"))),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_quesanalyze"),
            size: "small",
            prop: "explainText",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.explainText,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "explainText", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }